<template lang="pug">
.lp-switcher(:class="{ open }")
  a.selected(target="_blank", :href="`?${ lp }`", :title="title") {{ lp }}
  .toggle(@click="open = !open")
  .options(v-show="open")
    .option(v-for="option in filteredOptions", @click="select(option)") {{ option }}
    .option.divider(v-if="filteredOptions.length") &nbsp;
    .option.new(@click="create") new
</template>
<script>
import { licensePlate } from '@/helpers';
export default {
  name: 'checkbox',
  data() {
    return { open: false };
  },
  props: {
    value: String,
    options: Array,
    href: String,
    prefix: {
      type: String,
      default: 'c'
    },
    title: String
  },
  computed: {
    filteredOptions() {
      const { options = [], value } = this;
      return options?.filter(item => item !== value) || [];
    },
    hasOptions() {
      return !!this.options?.length;
    },
    lp: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    create() {
      this.lp = this.prefix + licensePlate();
      this.open = false;
    },
    select(value) {
      this.lp = value;
      this.open = false;
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.lp-switcher {
  position: relative;
  display: inline-block;
  max-height: 1.25rem;
  margin-right: 0.5rem;
  margin-top: 0.125rem;
  text-decoration: none;
  color: $brn;
  padding: 0.125rem 0.4rem;
  border: 1px solid $brn;
  border-radius: 3px;
  z-index: 2;
  padding-right: 1.125rem;
  // &.hasOptions {
  // }
  &.open {
    .toggle::after {
      //transform: rotate(-90deg);
      transform: rotate(-90deg) translate3d(0, -150vw, 0);
    }
  }
  .selected {
    display: inline-block;
    min-width: 5.2rem;
    text-decoration: none;
    color: $brn;
    cursor: pointer;
  }
  .toggle {
    position: absolute;
    top: 0.18rem;
    //top: 0.38rem;// topo only
    right: 0.25rem;
    &::after {
      position: absolute;
      top: 0;
      left: 50%;
      cursor: pointer;
      user-select: none;
      color: #777;
      display: inline-block;
      width: 1rem;
      height: 1rem;
      content: '\BB';
      font-size: 1.5rem;
      transform-origin: center;
      transform: rotate(90deg) translate3d(0, 50%, 0);
    }
  }
  .options {
    position: absolute;
    top: 100%;
    left: 3px;
    right: 3px;
    border: 1px solid $brn;
    background-color: white;
    padding-top: 0.5rem;
    cursor: pointer;
    text-align: left;
    box-sizing: border-box;
    padding-bottom: 0.25rem;
    margin-bottom: 0.25rem;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    box-shadow: 0 1px 3px rgba($brn, 0.7);
    .option {
      padding-left: 0.4rem;
      border-left: 2px solid transparent;
      transition: all 200ms ease-in-out;
      // will-change: transform;
      &:hover:not(.divider) {
        border-left-color: $brn;
        transform: translate3d(4px, 0, 0);
      }
      &.divider {
        margin: 0.25rem;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        height: 1px;
        background-color: rgba($brn, 0.3);
      }
      &.new {
        //border-top: 1px solid rgba($brn, 0.3);
        // margin-top: 0.25rem;
        // padding-top: 0.25rem;
      }
    }
  }
}
</style>
